export const SET_SCROLLED_LINE_NUMBER = 'waitrose/scroll-session-storage/STORE_LINE_NUMBER';
export const RESTORE_GLOBAL_SCROLL_STATE =
  'waitrose/scroll-session-storage/RESTORE_GLOBAL_SCROLL_STATE';
